import { AnimatePresence } from "framer-motion";
import { useModal } from "../../context/ModalContext";
import OktoberfestModal from "./oktoberfest/OktoberfestModal";
import PopupNovita from "./news/PopupNovita";

const ModalRoot = () => {
    const { activeModal, modalProps, closeModal } = useModal();

    return (
        <AnimatePresence>
            {activeModal === "oktoberfest" && (
                <OktoberfestModal onClose={closeModal} />
            )}

            {activeModal === "weeklyNew" && (
                <PopupNovita
                    isOpen={true} 
                    onClose={closeModal} 
                    product={modalProps.product} 
                    onViewDetail={modalProps.onViewDetail} 
                />
            )}
        </AnimatePresence>
    );
};

export default ModalRoot;